<template>
  <div
    :class="[
      dialogVisible
        ? 'select-address-group select-address-group-active el-area-selector'
        : 'select-address-group el-area-selector',
    ]"
    id="scma-area-selector"
    
  >
    <div
      :style="{ width: selectedWidth }"
      class="selected-adress clearfix"
      ref="selected-adress"
      
    >
      <el-input v-model="areaShow" placeholder="请选择所在地" @focus="handleChangeDislog"></el-input>
      
    </div>
    <el-card :style="style" class="box-card9">
      <div class="item-tab">
        <el-tabs type="card" v-model="editableTabsValue">
          <el-tab-pane
            :key="index"
            :label="item.title"
            :name="item.name"
            v-for="(item, index) in editableTabs"
          >
            <span @click="gitProvince2(item)" slot="label">
              {{ item.title }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <ul>
              <li
                :class="[
                  parseInt(flag) === e.code ? 'choosed' : '',
                  e.name.length <= 8
                    ? 'widthClassshort'
                    : e.name.length > 8 && e.name.length <= 12
                    ? 'widthClasslong'
                    : 'widthClassSuperlong',
                ]"
                :key="e.code"
                @click="gitProvince(e)"
                data-class
                v-for="e in item.content"
              >
                {{ e.name }}
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
import Axios from "axios";
import { getCountryList } from "@/api/subcontractor-register";
export default {
  name: "ElAreaSelector",
  props: {
    defaultArea: Array,
    place: {
      type: String,
      default: "left",
    },
    url: {
      type: String,
      default: "",
    },
    headers: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectedWidth: {
      type: String,
      default: "",
    },
    agentId: {
      type: String,
      default: "",
    },
    areaShow: String,
  },
  watch: {
    async defaultArea(val) {
      if (val && val.length > 0) {
        await this.qryAddressOfFourthCountry();
        console.log("qryAddressOfFourthCountry success");
        // await this.qryAddressOfFourth();
        if (val && val.length > 0) {
          this.defaultAreaScoped = JSON.parse(JSON.stringify(this.defaultArea));
          this.content = JSON.parse(JSON.stringify(this.defaultArea));
          for (let i = 0; i < val.length; i++) {
            await this.qryAddressOfFourth(val[i], "", true);
            console.log("qryAddressOfFourth i", i);
          }
          this.flag = val[val.length - 1].code;
          this.editableTabsValue = `${val.length}`;
          this.showDefault();
        } else {
          this.showDefault();
          this.addDefaultAreaScoped();
        }
      }
    },
  },
  data() {
    return {
      maskWidth: "0",
      dialogVisible: false,
      areaShow: "",
      content1: "",
      content2: "",
      content3: "",
      content4: "",
      content: JSON.parse(JSON.stringify(this.defaultArea)),
      flag: 0,
      editableTabsValue: "1",
      widthClass: "",
      editableTabs: [
        {
          title: "请选择地址",
          name: "1",
          content: [],
        },
      ],
      tabIndex: 2,
      a: 2,
    };
  },
  mounted() {
    this.defaultAreaScoped = JSON.parse(JSON.stringify(this.defaultArea));
    this.$nextTick(() => {
      this.showDefault();
      this.qryAddressOfFourthCountry();
      //this.qryAddressOfFourth();
      this.addDefaultAreaScoped();
    });
  },
  computed: {
    style() {
      let style = {};
      if (this.place === "left") {
        style.left = "0";
      } else {
        style.right = "0";
      }
      return style;
    },
  },
  methods: {
    showDefault() {
      let showArr = [];
      if (this.content.length !== 0) {
        this.content.forEach((item) => {
          showArr.push(item.name);
        });
      }

      if (showArr) {
        this.areaShow = showArr.join("");
      }
      this.$nextTick(function () {
        this.maskWidth = this.$refs["selected-adress"].clientWidth - 2 + "px";
      });
    },
    addDefaultAreaScoped() {
      if (this.defaultAreaScoped && this.defaultAreaScoped.length === 4) {
        this.editableTabs = [
          {
            title: this.defaultAreaScoped[0].name,
            name: "1",
            content: [],
          },
          {
            title: this.defaultAreaScoped[1].name,
            name: "2",
            content: [],
          },
          {
            title: this.defaultAreaScoped[2].name,
            name: "3",
            content: [],
          },
          {
            title: this.defaultAreaScoped[3].name,
            name: "4",
            content: [],
          },
        ];
        this.qryAddressOfFourth(
          this.defaultAreaScoped[2],
          this.defaultAreaScoped[3].name,
          true
        );
        this.flag = this.defaultAreaScoped[3].code;
        this.editableTabsValue = "4";
        // this.editableTabsValue = '4'
      } else if (
        this.defaultAreaScoped &&
        this.defaultAreaScoped.length === 3
      ) {
        this.editableTabs = [
          {
            title: this.defaultAreaScoped[0].name,
            name: "1",
            content: [],
          },
          {
            title: this.defaultAreaScoped[1].name,
            name: "2",
            content: [],
          },
          {
            title: this.defaultAreaScoped[2].name,
            name: "3",
            content: [],
          },
        ];
        this.qryAddressOfFourth(
          this.defaultAreaScoped[1],
          this.defaultAreaScoped[2].name,
          true
        );
        this.flag = this.defaultAreaScoped[2].code;
        this.editableTabsValue = "3";
        // this.editableTabsValue = '4'
      }
    },
    qryAddressOfFourth(data, name, flag) {
      let tmpCode = "0";
      if (!data || (data && (data.code === 142 || data.code === "142"))) {
        tmpCode = "0";
      } else {
        tmpCode = data.code;
      }
      return new Promise((resolve, reject) => {
        Axios({
          method: "post",
          url: this.url,
          // headers: { 'Authorization': this.access_token || '' },
          headers: this.headers,
          data: {
            zaddvsup: tmpCode,
            pageNo: 1,
            pageSize: 1000,
            agentId: this.agentId,
          },
        })
          .then((res) => {
            if (!Array.isArray(res.data.data)) {
              res.data.data = res.data.data.rows;
            }
            let result = res.data.data;
            result.forEach((item) => {
              this.$set(item, "code", item.zaddvscode);
              this.$set(item, "name", item.zaddvsname);
              if (data === undefined) {
                item.level = 2;
              } else {
                item.level = data.level + 1;
              }
            });
            if (data && data.level === 1) {
              this.editableTabs[0].title = data.name;
              this.content1 = data;
              this.content2 = "";
              this.content3 = "";
              this.content4 = "";
              if (!this.content) {
                this.content = [];
                this.content.splice(0, 1, data);
              } else {
                this.content.splice(0, 1, data);
              }
            }
            if (data && data.level === 2) {
              this.editableTabs[1].title = data.name;
              this.content2 = data;
              this.content3 = "";
              this.content4 = "";
              this.content.splice(1, 1, data);
            }
            if (data && data.level === 3) {
              this.editableTabs[2].title = data.name;
              this.content3 = data;
              this.content4 = "";
              this.content.splice(2, 1, data);
            }
            if (data && data.level === 4) {
              this.editableTabs[3].title = data.name;
              this.content.splice(3, 1, data);
              this.content4 = data;
            }
            if (result.length === 0) {
              let showArr = [];
              this.content.splice(data.level, this.content.length - data.level);
              this.content.forEach((item) => {
                showArr.push(item.name);
              });
              this.editableTabs.splice(
                data.level,
                this.editableTabs.length - data.level
              );
              this.areaShow = showArr.join("");
              this.$emit("getAddressOf", this.content);
              console.log(
                "this.editableTabs qryAddressOfFourth data name flag",
                data,
                name,
                flag
              );
              console.log(
                "this.editableTabs qryAddressOfFourth",
                this.editableTabs
              );
              this.maskWidth =
                this.$refs["selected-adress"].clientWidth - 2 + "px";

              this.dialogVisible = false;
            } else {
              if (flag && data) {
                this.flag = data.code;
              }
              if (flag) {
                if (data.level === 1) {
                  this.editableTabsValue = "2";
                  this.editableTabs = this.editableTabs.filter(
                    (tab) => tab.name === "1"
                  );
                  let obj = { title: "请选择", name: "2", content: [] };
                  this.editableTabs.splice(1, 1, obj);
                }
                if (data.level === 2) {
                  this.editableTabsValue = "3";
                  this.editableTabs = this.editableTabs.filter(
                    (tab) => tab.name === "1" || tab.name === "2"
                  );
                  let obj = { title: "请选择", name: "3", content: [] };
                  this.editableTabs.splice(2, 1, obj);
                }
                if (data.level === 3) {
                  this.editableTabs = this.editableTabs.filter(
                    (tab) =>
                      tab.name === "1" || tab.name === "2" || tab.name === "3"
                  );
                  this.editableTabsValue = "4";
                  let obj = { title: "请选择", name: "4", content: [] };
                  this.editableTabs.splice(3, 1, obj);
                }
              }
              if (result[0].level === 1) {
                this.editableTabs[0].content = result;
              } else if (result[0].level === 2) {
                this.editableTabs[1].content = result;
              } else if (result[0].level === 3) {
                this.editableTabs[2].content = result;
              } else if (result[0].level === 4) {
                this.editableTabs[3].content = result;
              }
              console.log(
                "this.editableTabs qryAddressOfFourth data name flag",
                data,
                name,
                flag
              );
              console.log(
                "this.editableTabs qryAddressOfFourth",
                this.editableTabs
              );
            }
            resolve({});
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    qryAddressOfFourthCountry(data, name, flag) {
      return new Promise((resolve, reject) => {
        getCountryList({
          zcountryname: "中国",
          pageNo: 1,
          pageSize: 1000,
        })
          .then((res) => {
            if (!Array.isArray(res.data.data)) {
              res.data.data = res.data.data.rows;
            }
            let result = res.data.data;
            result.forEach((item) => {
              this.$set(item, "code", item.zcountrycode);
              this.$set(item, "name", item.zcountryname);
              if (!data) {
                item.level = 1;
              } else {
                item.level = data.level + 1;
              }
            });
            if (result.length === 0) {
              let showArr = [];
              this.content.splice(data.level, this.content.length - data.level);
              this.content.forEach((item) => {
                showArr.push(item.name);
              });
              this.editableTabs.splice(
                data.level,
                this.editableTabs.length - data.level
              );
              console.log("this.editableTabs 0", this.editableTabs);
              this.areaShow = showArr.join("");
              this.$emit("getAddressOf", this.content);

              this.maskWidth =
                this.$refs["selected-adress"].clientWidth - 2 + "px";

              this.dialogVisible = false;
            } else {
              if (result[0].level === 1) {
                this.editableTabs[0].content = result;
              }
              console.log("this.editableTabs", this.editableTabs);
            }
            resolve({});
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    gitProvince(item) {
      this.qryAddressOfFourth(item, "", true);
    },
    gitProvince2(item) {
      if (item.name === "1") {
        this.flag = this.content[0].code;
        this.qryAddressOfFourthCountry();
      }
      if (item.name === "2" && this.editableTabs.length > 2) {
        this.flag = this.content[1].code;
        if (
          this.editableTabs[1].content &&
          this.editableTabs[1].content.length > 0
        ) {
          this.qryAddressOfFourth(this.content[0], this.content[1].name);
        } else {
          this.qryAddressOfFourth(this.content[1], this.content[2].name, true);
        }
        //this.qryAddressOfFourth(this.content[0], this.content[1].name);
      }
      if (item.name === "3" && this.editableTabs.length > 2) {
        this.flag = this.content[2].code;
        if (
          this.editableTabs[2].content &&
          this.editableTabs[2].content.length > 0
        ) {
          this.qryAddressOfFourth(this.content[1], this.content[2].name);
        } else {
          this.qryAddressOfFourth(this.content[1], this.content[2].name, true);
        }
      }
      if (item.name === "4" && this.editableTabs.length > 2) {
        this.flag = this.content[3].code;
      }
    },
    handleChangeDislog() {
      this.dialogVisible = true;
      console.log(this.dialogVisible);
    },
  },
};
</script>
<style lang="scss">
#scma-area-selector{
  width: 100%;
}
#scma-area-selector
  .box-card9
  .el-card__body
  .item-tab
  .el-tabs
  .el-tabs__header
  .is-active {
  color: #0d7adf !important;
  -webkit-box-sizing: content-box !important;
  box-sizing: content-box !important;
  border-left: 2px solid #df0d3e !important;
  border-right: 2px solid #df0d3e !important;
  border-top: 2px solid #df0d3e !important;
  border-bottom: 2px solid #fff;
}
#scma-area-selector
  .box-card9
  .el-card__body
  .item-tab
  .el-tabs
  .el-tabs__header {
  border-bottom: 2px solid #df0d3e;
}
#scma-area-selector
  .box-card9
  .el-card__body
  .item-tab
  .el-tabs
  .el-tabs__content
  ul
  li {
  white-space: nowrap;
  text-align: center;
  margin-bottom: 10px;
  font-size: 13px;
  color: #666666;
  cursor: pointer;
}
#scma-area-selector .el-tabs__content {
  overflow: inherit;
  position: relative;
}
#scma-area-selector .box-card9 {
  position: absolute;
  /* overflow: inherit; */
  width: 590px;
  top: 41px;
  min-height: 348px;
  z-index: 9;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}
#scma-area-selector .el-card__body {
  padding: 10px;
}
</style>
<style lang="scss" scoped>
.el-area-selector .selected-adress {
  height: 40px;
  .selected-show {
    min-width: 228px;
    height: 40px;
    line-height: 28px;
    padding: 0 20px 0 9px;
    font-size: 13px;
    color: #4a4a4a;
    display: block;
    border: 1px solid #e9e9e9;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
 /deep/ .el-input.is-disabled .el-input__inner {
    cursor: text;
    background-color: #FFF;
    color: #4A4A4A;
 }
</style>
